enum TableDataRowTypes {
  DATE_ADD = 'DATE_ADD',
  IS_ACTIVE = 'IS_ACTIVE',
  CATEGORY_TAG = 'CATEGORY_TAG',
  IMAGE = 'IMAGE',
  VIDEO = 'VIDEO',
  SORT = 'SORT',
  VIEWS = 'VIEWS',
  NAME_LINK = 'NAME_LINK',
  FIELD_NEWS_TYPE = 'FIELD_NEWS_TYPE',
  FIELD_NEWS_CATEGORY = 'FIELD_NEWS_CATEGORY',
  FIELD_NEWS_SECTIONS = 'FIELD_NEWS_SECTIONS',
  MODULES = 'MODULES',
  NAWOZY_TV_TYPE = 'NAWOZY_TV_TYPE',
  IS_NEWS = 'IS_NEWS',
  DATE_LOGIN = 'DATE_LOGIN',
  AVATAR = 'AVATAR',
  CUSTOM_IMAGE = 'CUSTOM_IMAGE',
  BANNERS = 'BANNERS',
  IS_ASK = 'IS_ASK',
  COLOUR = 'COLOUR',
  FERTILIZER_IMAGE = 'FERTILIZER_IMAGE',
  HAS_PARAMETERS = 'HAS_PARAMETERS',
  GTW_REQUIREMENT = 'GTW_REQUIREMENT',
  GTW_DATE = 'GTW_DATE',
  GTW_STATUS = 'GTW_STATUS',
  REPRESENTATIVE = 'REPRESENTATIVE',
}

export default TableDataRowTypes;
